import React from "react";
import { Navigate } from "react-router-dom";

function PrivateRoutes({ children }) {
  const data = localStorage.getItem("data");
  let auth = null;
  try {
    auth = data ? JSON.parse(data) : null;
  } catch {
    auth = null;
  }
  const accessToken = auth?.accessToken || auth?.access_token || auth?.token;
  return <>{accessToken ? children : <Navigate to="/login" />}</>;
}

export default PrivateRoutes;
